module.exports = __webpack_public_path__ + "static/img/entri-bg.a5b29a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/index/entri-bg.png
// module id = JQ6Q
// module chunks = 4